<template>
  <div>
    <div id="k_chart"></div>
    <div class="k_time"><span>{{t1}}</span><span>{{t2}}</span></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
    props:{
        k_node_list:{
            type : Array
        }
    },
    data(){
        return{
            t1:'',
            t2:''
        }
    },
    mounted(){
        this.k_chart();
    },
    watch:{
        k_node_list:{
            handler(val,oldVal){
                if(val){
                    this.k_chart();
                }
            },
            deep:true
        }
    },
    methods:{
        k_chart(){
            var upColor = '#FE484A';
            var upBorderColor = '#FE484A';
            var downColor = '#0AC890';
            var downBorderColor = '#0AC890';

            function fontSize(res){
                let docEl = document.documentElement,
                    clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
                if (!clientWidth) return;
                let fontSize = (clientWidth / 750);
                return res*fontSize;

            }

            // 数据意义：开盘(open)，收盘(close)，最低(lowest)，最高(highest)

            var kdata = this.k_node_list;

            function splitData(rawData) {
                var categoryData = [];
                var values = []
                var press = []
                var support = []
                for (var i = 0; i < rawData.length; i++) {
                    categoryData.push(rawData[i].date);
                    press.push(rawData[i].press);
                    support.push(rawData[i].support);
                    values.push([rawData[i].open, rawData[i].close, rawData[i].low, rawData[i].high,])
                }
                return {
                    categoryData: categoryData,
                    values: values,
                    press:press,
                    support,support
                };
            }
            var categoryData = splitData(kdata).categoryData;
            this.t1 = categoryData[0];
            this.t2 = categoryData[categoryData.length-1];
            var values = splitData(kdata).values;
            var press = splitData(kdata).press;
            var support = splitData(kdata).support;

            var option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        lineStyle: {
                            color: '#CDCDCD',	//显示竖线颜色
                            width:1.5,
                            type:'solid',
                        }
                    },
                    textStyle: {
                        color: '#333333',
                        fontSize:fontSize(22),
                    },
                    backgroundColor:'#FFFBFB',	//tooltip背景色
                    borderColor:'#FFA391',		//tooltip边框颜色
                    borderWidth:3,
                    formatter: function (param) {	//自定义tooltip内容
                        var text = '';
                        text += '<div>'+param[0].name+'</div>';
                        text += '<div>'+param[0].seriesName+'</div>';
                        text += '<div>开盘价：'+param[0].data[1]+'</div>';
                        text += '<div>最高盘：'+param[0].data[4]+'</div>';
                        text += '<div>最低价：'+param[0].data[3]+'</div>';
                        text += '<div>收盘价：'+param[0].data[2]+'</div>';
                        text += '<div style="color:#448DFE;">压力位：'+param[1].data+'</div>';
                        text += '<div style="color:#FE484A;">支撑位：'+param[2].data+'</div>';
                        return text;
                    }
                },

                grid:{
                    x:5,
                    y:5,
                    x2:5,
                    y2:5
                },
                xAxis: {
                    type: 'category',
                    data: categoryData,
                    scale: true,
                    boundaryGap: false,
                    axisLine: {
                        show:false,
                    },
                    axisTick: {    // 坐标轴 刻度
                        show: false,  // 是否显示
                    },
                    splitLine: {show: false},
                    splitNumber: 20,
                    min: 'dataMin',
                    max: 'dataMax',
                    axisLabel:{
                        show: false,  // 是否显示
                    }
                },
                yAxis: {
                    scale: true,
                    axisLine: {
                        show:false,
                    },
                    axisTick: {    // 坐标轴 刻度
                        show: false,  // 是否显示
                    },
                    splitLine: {show: false},
                    axisLabel:{
                        color: '#939393',  // 默认取轴线的颜色
                        fontSize:fontSize(18),
                        formatter:function (value) {
                            if(value == press[0] || value == support[0]){
                                return value;
                            }
                            else{
                                return '';
                            }
                        }
                    }

                },
                series: [
                    {
                        name: 'K线图',
                        type: 'candlestick',
                        data: values,
                        itemStyle: {
                            color: upColor,
                            color0: downColor,
                            borderColor: upBorderColor,
                            borderColor0: downBorderColor
                        },
                    },
                    {
                        name: '压力位',
                        type: 'line',
                        data: press,
                        smooth: true,
                        lineStyle: {
                            opacity: 1,
                            color:"#63A0FF",
                        },
                        symbol:'circle',
                        showSymbol:true,
                        color: "#63A0FF",//拐点样式
                        symbolSize:0,
                        itemStyle:{
                            normal:{
                                label: {
                                    show: true,
                                    position: [-5,-10],
                                    textStyle: {
                                        color: '#939393',
                                        fontSize:fontSize(18),
                                        fontWeight:'bold',
                                        backgroundColor:'rgba(225,225,225,0.3)',
                                    },
                                    formatter: (params) => {
                                        //console.log(params);
                                        if (params.dataIndex == 0) {
                                            return params.value
                                        } else {
                                            return ""
                                        }
                                    },
                                },
                            },
                            emphasis: {          //突出效果配置(鼠标置于拐点上时)
                                borderColor: '#fff',    //  拐点边框颜色
                                borderWidth: 2,         //  拐点边框宽度
                                shadowColor: '#63A0FF', //  阴影颜色
                                shadowBlur: 10,          //  阴影渐变范围控制
                            },
                        }
                    },
                    {
                        name: '支撑位',
                        type: 'line',
                        data: support,
                        smooth: true,
                        lineStyle: {
                            opacity: 1,
                            color:"#FE484A",
                        },
                        symbol:'circle',
                        showSymbol:true,
                        color: "#FE484A",//拐点样式
                        symbolSize:0,
                        itemStyle:{
                            normal:{
                                label: {
                                    show: true,
                                    position: [-5,-10],
                                    textStyle: {
                                        color: '#939393',
                                        fontSize:fontSize(18),
                                        fontWeight:'bold',
                                        backgroundColor:'rgba(225,225,225,0.3)',
                                    },
                                    formatter: (params) => {
                                        //console.log(params);
                                        if (params.dataIndex == 0) {
                                            return params.value
                                        } else {
                                            return ""
                                        }
                                    },
                                },
                            },
                            emphasis: {          //突出效果配置(鼠标置于拐点上时)
                                borderColor: '#fff',    //  拐点边框颜色
                                borderWidth: 2,         //  拐点边框宽度
                                shadowColor: '#FE484A', //  阴影颜色
                                shadowBlur: 10,          //  阴影渐变范围控制
                            },
                        }
                    }

                ]
            };
            var myChart = echarts.init(document.getElementById('k_chart'));
            myChart.setOption(option);
        },
    }
}
</script>

<style lang="scss">
  .k_time{
    font-size: 0.24rem;
    color: #939393;
    position: relative;
    line-height: 0.4rem;
    >span:nth-child(2){
      position: absolute;
      right: 0;
    }
  }
</style>